import styled from 'styled-components';
import { LINE_GRAY } from '../colors';
import { marginVerticalKeys, marginVerticalMixin } from '../mixins/layout';
import { withOmitProps } from '../helpers/elements';
const Hr = styled.hr.withConfig(withOmitProps([...marginVerticalKeys]))`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${LINE_GRAY};
  margin: 0;
  ${marginVerticalMixin}
`;
export default Hr;